<template>
  <Knowledge :type="3" />
</template>

<script>
import Knowledge from '@/components/experimentation/knowledge.vue'
export default {
  components: { Knowledge },
}
</script>